<template>
    <fieldset class="interested-in-app-fieldset" v-if="$globals.show_interested_in_app || false">
        <div
            class="flex w-full flex-wrap interested-in-app-container mt-8 mb-8 text-white"
        >
            <div class="flex w-full p-4">
                <div>
                    <span class="text-2xl"
                        >Looking to save time? <b>App time!</b></span
                    >
                </div>
            </div>
            <div class="flex w-full">
                <div class="flex w-full p-4 flex-grow">
                    <div>
                        <p>
                            The Little Loans App lets you store your result and
                            see all the <b>best deals in an instant.</b>
                        </p>

                        <ul class="interested-in-app-list">
                            <li class="mb-2 leading-tight">
                                <span>Always <b>FREE</b> to use</span>
                            </li>
                            <li class="mb-2 leading-tight">
                                <span
                                    >Manage your <b>loan application</b> and
                                    store the results</span
                                >
                            </li>
                            <li class="mb-2 leading-tight">
                                <span><b>Exclusive</b> offers and deals</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="flex flex-row items-end">
                    <div class="flex">
                        <img
                            srcset="
                                /img/interested-in-app.png,
                                /img/interested-in-app@2x.png 1.5x,
                                /img/interested-in-app@3x.png 2.5x
                            "
                            src="/img/interested-in-app.png"
                            alt="little loans app"
                            width="58"
                            height="128"
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full flex">
            <fancy-select
                :validation-disabled="true"
                :vid="this.name + '.interestedInApp'"
                :name="this.name + '.interestedInApp'"
                label="Send me a link by email and text to download my Little Loans App. You can opt out at anytime. "
                v-model="interestedInApp"
                :options="defaultOptions"
                :rules="{ required: false, in: Object.keys(defaultOptions) }"
                :custom-messages="this.$getValidationMessages(name)"
                @input="update"
                class="mb-8"
                type="toggle"
            ></fancy-select>
        </div>
    </fieldset>
</template>

<script>
import FancySelect from './../../components/form/fancyselect'
export default {
    inject: ['$getValidationRules', '$getValidationMessages', '$globals'],
    watch: {
        '$globals': {
            deep: true,
            immediate: true,
            handler() {
                if (this.$globals.show_interested_in_app) {
                    this.update();
                }
            },
        }
    },
    methods: {
        update() {
            this.$emit('input', this.interestedInApp);
        }
    },
    computed: {},
    props: {
        name: String,
        value: [String, Boolean],
        defaultOptions: Object,
        extraOptions: Object,
    },
    data() {
        return {
            interestedInApp: "1"
        }
    },
    components: {
        'fancy-select': FancySelect,
    },
}
</script>

<style lang="scss">
.interested-in-app-fieldset {
    .valid {
        .form-label {
            transform: none;
            &::before {
                transform: scale(0);
            }
        }
    }
}
.interested-in-app-container {
    
    background: linear-gradient(261.76deg, #10e6cd 2.37%, #4cb8c4 72.72%);
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}
.interested-in-app-list {
    list-style: none;
    padding: 0;
    li {
        &::before {
            content: '';
            display: inline-block;
            background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z' fill='white'/%3E%3Cpath d='M6.54235 10.0671L4.64582 8.20134L4 8.83221L6.54235 11.3333L12 5.9642L11.3587 5.33333L6.54235 10.0671Z' fill='%234CB8C4'/%3E%3C/svg%3E%0A");
            height: 16px;
            width: 16px;
            margin-right: 8px;
            top: 2px;
            position: relative;
        }
    }
}
</style>
